import React, { useState, useEffect, useRef } from "react";
import lock from "../../assets/images/Lock.svg";
import "./OddButton.scss";
import { connect } from "react-redux";
import { RootState } from "../../models/RootState";

type pageProps = {
  data: any;
  providerId: string;
  marketName: string;
  eventStatus?: boolean;
  onClick: (data) => void;
};

const OddButton: React.FC<pageProps> = (props) => {
  const { data, providerId, marketName, eventStatus, onClick } = props;
  const [classesBack, setClassesBack] = useState<string>("button-content back");
  const [classesLay, setClassesLay] = useState<string>("button-content lay");
  const timer = useRef<NodeJS.Timeout | null>(null);
  const [currentValueBack, setCurrentValueBack] = useState<number>(null);
  const [currentValueLay, setCurrentValueLay] = useState<number>(null);

  const getValueByName = (name: string) => {
    let value = name && name.length ? name.split(" (") : [];
    return value.length && value[1] ? "(" + value[1] : "";
  };

  useEffect(() => {
      return () => {
          if (timer.current) {
              clearTimeout(timer.current);
          }
      };
  }, []);

  useEffect(() => oddValueChanged(), [data]);
  const oddValueChanged = () => {
    if (timer.current) {
      clearTimeout(timer.current);
    }
    const chValBack = data[0]?.price;
    const chValLay = data[1]?.price;

    if (chValBack) {
      const cVal = currentValueBack;
      setCurrentValueBack(chValBack);
      let showAnimation = true;
      if (showAnimation) {
        if (cVal && chValBack !== cVal) {
          setClassesBack(prev => prev.replace(" odd-change", ""));
          timer.current = setTimeout(() => {
              setClassesBack(prev =>
                  prev.replace(" odd-change", "")
              );
          }, 3000);
        }
      }
    } else if (chValLay) {
      const cVal = currentValueBack;
      setCurrentValueLay(chValLay);
      let showAnimation = true;
      if (showAnimation) {
        if (cVal && chValLay !== cVal) {
          setClassesLay(prev => prev.replace(" odd-change", ""));
          timer.current = setTimeout(() => {
              setClassesBack(prev =>
                  prev.replace(" odd-change", "")
              );
          }, 3000);
        }
      }
    }
  };

  return (
    <>
      {providerId === "SportRadar" ? (
        <div className="exch-odd-view">
          {data && data.length
            ? data.map((d, i) => (
                <div className="odd-button-content" key={i}>
                  <div className="price">
                    {d?.back && eventStatus ? (
                      <>
                        {" "}
                        {marketName !== "winner" ? (
                          <div className="value">{getValueByName(d.name)}</div>
                        ) : null}
                        {Number(d?.back).toFixed(2)}
                      </>
                    ) : (
                      <img src={lock} className="lock-img" alt="lock-img" />
                    )}
                  </div>
                </div>
              ))
            : null}
        </div>
      ) : (
        <>
          <div className="exch-odd-view">
            {data[0]?.price === 0 ? (
              <div className="button-content back">
                <div className="price">
                  <img src={lock} className="lock-img" alt="lock-img" />
                </div>{" "}
              </div>
            ) : (
              <div
                className={classesBack}
                onClick={() =>
                  onClick({ oddValue: data[0]?.price, betType: "BACK" })
                }
              >
                <div className="price">
                  {data[0] ? Number(data[0]?.price).toFixed(2) : "-"}
                </div>{" "}
                <div className="size">
                  {data[0]?.size > 999
                    ? Number(data[0]?.size / 1000).toFixed(2) + "K"
                    : Number(data[0]?.size).toFixed(2)}
                </div>
              </div>
            )}
            {data[1]?.price === 0 ? (
              <div className="button-content lay">
                <div className="price">
                  <img src={lock} className="lock-img" alt="lock-img" />
                </div>{" "}
              </div>
            ) : (
              <div
                className={classesLay}
                onClick={() =>
                  onClick({ oddValue: data[1]?.price, betType: "LAY" })
                }
              >
                <div className="price">{Number(data[1]?.price).toFixed(2)}</div>{" "}
                <div className="size">
                  {/* {Number(data[1]?.size).toFixed(2)} */}
                  {data[1]?.size > 999
                    ? Number(data[1]?.size / 1000).toFixed(2) + "K"
                    : Number(data[1]?.size).toFixed(2)}
                </div>
              </div>
            )}
          </div>
        </>
      )}
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    providerId: state.auth.providerId,
  };
};

export default connect(mapStateToProps, null)(OddButton);
